module.exports = __webpack_public_path__ + "static/media/cookiesPolicy.99f68c33.png";